import { match } from 'ts-pattern'

import { VerifierType } from '@frame/lib/api/common/types'

import { ClientSessionState, VerificationType } from '../api/client-session/types'

export function getTextForVerificationType(verificationType?: VerificationType): string {
  if (!verificationType) return ''

  return match(verificationType)
    .with(VerificationType.EMPLOYMENT, () => 'employment')
    .with(VerificationType.EMPLOYMENT_INCOME, () => 'income and employment')
    .with(VerificationType.INCOME_ONLY, VerificationType.TENANT_SCREENING, () => 'income')
    .with(VerificationType.ASSETS_ONLY, () => 'assets')
    .exhaustive()
}

export function isSessionInTerminalState(sessionState?: ClientSessionState) {
  if (!sessionState) return false

  switch (sessionState) {
    case ClientSessionState.TERMINAL_COMPLETE:
    case ClientSessionState.TERMINAL_COMPLETE_BY_OTHER_STRATEGY:
    case ClientSessionState.TERMINAL_EXPIRED:
    case ClientSessionState.TERMINAL_FAILED:
    case ClientSessionState.TERMINAL_FALLBACK:
      return true
    default:
      return false
  }
}

export function getVerifierDisplayName(
  verifierType?: string,
  verifierName?: string,
  tenantPropertyName?: string | null
): string {
  // Use tenantPropertyName as displayName if verifierType is tenant, else use verifierName
  const isTenantVerifier = verifierType && verifierType === VerifierType.TENANT
  if (isTenantVerifier && tenantPropertyName) {
    return tenantPropertyName
  } else if (verifierName) {
    return verifierName
  } else {
    return 'the verifier'
  }
}

export function getMortgageOrTenantContact(verifierType?: string): string {
  return match(verifierType)
    .with(VerifierType.TENANT, () => 'leasing team')
    .otherwise(() => 'loan officer')
}
